import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { UserAuthApiService } from '../../shared/services/auth/user-auth-api.service';
import { AuthStateService } from './auth-state.service';

export const protectedOnlyGuard: CanActivateFn = (_, state: RouterStateSnapshot) => {
  const userAuthApiService = inject(UserAuthApiService);
  const authStateService = inject(AuthStateService);

  return userAuthApiService.checkAuth().pipe(
    tap((isAuthenticated) => {
      // Mark that user is accessing a protected route
      authStateService.setOnProtectedRoute(isAuthenticated);
    }),
    catchError((error) => {
      authStateService.setOnProtectedRoute(false);
      return of(false);
    }),
    map((isAuthenticated) => {
      return isAuthenticated;
    })
  );
};
